import { Box, Tooltip, Typography } from "@mui/material";
import { FC, useMemo } from "react";
import FlagIcon from "../../../assets/icons/flag.svg";
import classes from "./SampleFlagTooltip.module.scss";

interface SampleFlagTooltipProps {
  creatorEmail: string;
  sampleId: string;
}

export const SampleFlagTooltip: FC<SampleFlagTooltipProps> = (
  props: SampleFlagTooltipProps,
) => {
  const { creatorEmail, sampleId } = props;

  const tooltipContent = useMemo(
    () => (
      <Box className={classes.tooltipContent}>
        <Typography className={classes.label}>Sample created by:</Typography>
        <Typography className={classes.value}>{creatorEmail}</Typography>
        <Typography className={classes.label} mt={1}>
          Sample ID:
        </Typography>
        <Typography className={classes.value}>{sampleId}</Typography>
      </Box>
    ),
    [creatorEmail, sampleId],
  );

  return (
    <Box className={classes.container}>
      <Tooltip title={tooltipContent} arrow>
        <img src={FlagIcon} alt="sample flag icon" />
      </Tooltip>
    </Box>
  );
};
